export default {
  pendencia() {
    this.$nextTick(() => {
      let arr = []
      this.rowsData = []
      this.htmlArr = []
      this.rows.forEach((el) => {
        arr.push(el.codigo)
        arr.push(el.unimed.nomeFantasia)
        arr.push(el.usuarioCaduCriacao.login)
        arr.push(el.usuarioCaduCriacao.nome)
        let s = `
            <div> ${el.dataCriacao.substring(0, 10)} </div>
          `
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)

        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  modalDirigentes() {
    this.$nextTick(() => {
      let arr = []
      this.rowsData = []
      this.htmlArr = []
      this.rows.forEach((el) => {
        arr.push(el.dirigente.tratamento)
        arr.push(el.dirigente.nome)
        let s = `
            <div> ${el.cargo.nome} </div>
          `
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  historicoAba() {
    this.$nextTick(() => {
      let arr = []
      this.rowsData = []
      this.htmlArr = []
      this.rows.forEach((el) => {
        arr.push(el.numero)
        arr.push(el.dataCriacao)
        arr.push(`${el.usuarioCaduCriacao.nome}`)
        arr.push(el.abasAlteradas)
        let s = `
            <div> ${el.dataAprovacao ? 'Sim' : 'Não'} </div>
          `
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  historico() {
    this.$nextTick(() => {
      let arr = []
      this.rowsData = []
      this.htmlArr = []

      let qtSeloNivelNull = this.rows.filter((e) => e.tipoSelo.nivel == null).length

      let totalSelos = this.rows.length

      this.rows.forEach((el) => {
        if (el.ano) arr.push(el.tipoSelo.nome + ' - ' + el.ano)
        else arr.push(el.tipoSelo.nome)

        arr.push(el.instituicaoResponsavel.nome)

        arr.push(el.dataInicio)
        arr.push(el.dataFim)

        if (qtSeloNivelNull != totalSelos) arr.push(el.tipoSelo.nivel)

        this.vigenciaArr.push(el.vigente)
        let a = '<div v-if="hoverIndex !== index" class="primary2 circle-status" style="margin-left:15px;"/>'
        let b = '<div class="error circle-status"        style="margin-left:15px; background-color: black;"/>'
        let s = el.vigente ? a : b
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  premiacoesMercado() {
    const tooltipoSub = (element) => {
      return element.length >= 20 ? { nome: `${element.substring(0, 19)}...`, tooltipColuna: element } : element
    }
    this.$nextTick(() => {
      let arr = []
      this.rowsData = []
      this.htmlArr = []
      this.rows.forEach((el) => {
        arr.push(tooltipoSub(el.nome))
        arr.push(tooltipoSub(el.institutoResponsavel))

        let s = `
            <div> ${el.dataPremiacao} </div>
          `
        let temp = document.createElement('div')
        temp = s

        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  modalArea() {
    let arr = []
    this.rowsData = []
    this.htmlArr = []
    this.iconArr = []
    this.$nextTick(() => {
      this.rows.forEach((el) => {
        arr.push(el.nome)
        arr.push(el.cargo.nome)
        arr.push(el.email.endereco)
        let s = '<span class="warningUtil2--text" style="font-size: 14px;"> ! </span>'

        let temp = document.createElement('div')

        if (el.email.statusEmail === 2) {
          this.iconArr.push({ name: 'check', size: 12, class: 'primary1--text' })
        } else if (el.email.statusEmail === 1) {
          this.iconArr.push(undefined)
          temp = s
        } else {
          this.iconArr.push({ name: 'x', size: 12, class: 'error--text' })
        }

        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  historicoPerfil() {
    this.rowsData = []
    this.htmlArr = []
    this.$nextTick(() => {
      let arr = []
      this.rows.forEach((el) => {
        arr.push(el.competencia);
        arr.push(el.dataAtualizacao);

        if (el.indexType == 0) {
          arr.push(el.tipoAtualizacao);
        }

        let s = `<div> ${el.usuarioAtualizacao.nome} </div>`
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  mandatos() {
    let arr = []
    this.rowsData = []
    this.htmlArr = []
    this.rows.forEach((el) => {
      arr.push(el.tipoMandato.nome)
      arr.push(el.dataInicioVigencia)
      arr.push(el.dataFimVigencia)
      let a = '<div class="primary2 circle-status"/>'
      let b = '<div class="error circle-status"/>'
      let s = el.vigente ? a : b
      let temp = document.createElement('div')
      temp = s
      this.htmlArr.push(temp)
      this.rowsData.push(arr)
      arr = []
    })
  },
  ans() {
    function addDecimalPoints(text) {
      let inputValue = text.replace('.', '').split('').reverse().join('') // reverse
      let newValue = ''
      for (let i = 0; i < inputValue.length; i++) {
        if (i % 3 === 0 && i !== 0) {
          newValue += '.'
        }
        newValue += inputValue[i]
      }
      return newValue.split('').reverse().join('')
    }

    let arr = []
    this.rowsData = []
    this.htmlArr = []
    this.rows.forEach((el) => {
      arr.push(el.tipoIntervencao.nome)
      arr.push(addDecimalPoints(el.resolucaoOperacional))
      arr.push(el.dataPublicacao)
      arr.push(el.diasValidade + ' dia(s)')
      let isVigente = el.vigente ? 'Vigente' : 'Não vigente'

      let s = `<div> ${isVigente} </div>`
      let temp = document.createElement('div')
      temp = s
      this.htmlArr.push(temp)
      this.rowsData.push(arr)
      arr = []
    })
  },
  areaAcao() {
    let arr = []
    this.rowsData = []
    this.htmlArr = []
    this.rows.forEach((el) => {
      arr.push(el.id)
      arr.push(el.nome)
      arr.push(el.sigla)
      let s = `<div></div>`
      let temp = document.createElement('div')
      temp = s
      this.htmlArr.push(temp)
      this.rowsData.push(arr)
      arr = []
    })
  },
  anexos() {
    this.rowsData = []
    this.rowsData = []
    this.htmlArr = []
    this.$nextTick(() => {
      let arr = []
      this.rows.forEach((el) => {
        arr.push(el.tipoDocumento.nome + ' - ' + el.anoDocumento)
        arr.push(el.abaRelacionada.nome)
        arr.push(el.dataUpload)
        let s = `<div> ${el.usuarioUpload.nome} </div>`
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  anexosAdmin() {
    this.rowsData = []
    this.rowsData = []
    this.htmlArr = []
    this.$nextTick(() => {
      let arr = []
      this.rows.forEach((el) => {
        arr.push(el.tipoDocumento.nome + ' - ' + el.anoDocumento)
        arr.push(el.abaRelacionada.nome)
        arr.push(el.dataUpload)
        let s = `<div> ${el.usuarioUpload.nome} </div>`
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr.push(el.unimed.textoExibicao)
        arr = []
      })
    })
  },
  consultarUnimed() {
    this.rowsData = []
    this.rowsData = []
    this.htmlArr = []
    let arr = []
    this.$nextTick(() => {
      this.rows.forEach((el) => {
        var verificoNomeFantasiaPrecisaTooltip =
          el.nomeFantasia.length >= 40
            ? { nome: el.nomeFantasia.substring(0, 39), tooltipColuna: el.nomeFantasia }
            : el.nomeFantasia
        arr.push(el.codigo)
        arr.push(verificoNomeFantasiaPrecisaTooltip)
        arr.push(el.tipoUnimed.nome)
        arr.push(el.tipoAtuacao.nome)
        arr.push(el.uf)

        let s = el.ativo ? `<div> Ativa </div>` : `<div> Inativa </div>`
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },

  tabelaDominio() {
    this.rowsData = []
    this.rowsData = []
    this.htmlArr = []
    this.$nextTick(() => {
      let arr = []
      this.rows.forEach((el) => {
        arr.push(el.tipoDominio.nome)
        arr.push(el.nome)
        arr.push(el.ordem)
        let color = el.ativo ? '#B1D34B' : '#ED1651'
        let s = `
            <div
                class="circle-status"
                style="background: ${color};"
            ></div>
          `
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  TabelaEmailAreas() {
    let arr = []
    this.rowsData = []
    this.iconArr = []
    this.htmlArrTooltip = []
    this.$nextTick(() => {
      this.rows.forEach((el) => {
        arr.push(el.unimed.textoExibicao)
        arr.push(el.tipoArea.nome)
        arr.push(el.email.endereco)
        let s = '<span class="warningUtil2--text" style="font-size: 14px;"> ! </span>'

        let temp = document.createElement('div')

        if (el.email.statusEmail === 2) {
          this.iconArr.push({ name: 'check', size: 12, class: 'primary1--text', tooltipName: 'Confirmado' })
        } else if (el.email.statusEmail === 1) {
          this.iconArr.push(undefined)
          temp = s
        } else if (el.email.statusEmail === 0) {
          this.iconArr.push({ name: 'x', size: 12, class: 'error--text', tooltipName: 'Não confirmado' })
        }

        this.htmlArrTooltip.push({ html: temp, tooltipName: 'Pendente' })
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  TabelaUsuarios() {
    this.rowsData = []
    this.rowsData = []
    this.htmlArr = []

    const tooltipoSub = (element) => {
      return element.length >= 25 ? { nome: `${element.substring(0, 25)}...`, tooltipColuna: element } : element
    }

    this.$nextTick(() => {
      let arr = []
      this.rows.forEach((el) => {
        arr.push(tooltipoSub(el.unimed.nomeCompleto))
        arr.push(el.nome)
        arr.push(el.login)
        let s = `<div> ${el.papel || '-'} </div>`
        let temp = document.createElement('div')
        temp = s
        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  TabelaTransacaoOnline() {
    let arr = []
    this.rowsData = []
    this.iconArr = []
    this.htmlArr = []
    this.$nextTick(() => {
      this.rows.forEach((el) => {
        arr.push(el.codigo)
        arr.push(el.nomeFantasia)
        arr.push(el.competencia)

        if (el.status) {
          const verificaTextoStatus =
            el.status.length > 70 ? { nome: `${el.status.substring(0, 50)}...`, tooltipColuna: el.status } : el.status
          //const corVerde = '#00995d'
          let color = el.sucesso ? '' : '#ED1651'

          if (el.status === 'Aguardando') {
            arr.push(verificaTextoStatus)
          } else {
            if (typeof verificaTextoStatus === 'object') {
              verificaTextoStatus.color = color
              arr.push(verificaTextoStatus)
            } else {
              let s = `<div style="color: ${color}"> ${verificaTextoStatus} </div>`
              let temp = document.createElement('div')
              temp = s
              this.htmlArr.push(temp)
            }
          }
        } else {
          arr.push('')
        }

        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  TabelaGerenciamentoToken() {
    let arr = []
    this.rowsData = []
    this.iconArr = []
    this.htmlArr = []
    this.$nextTick(() => {
      this.rows.forEach((el) => {
        var verificoNomeAplicacaoPrecisaTooltip =
          el.nome.length >= 18 ? { nome: `${el.nome.substring(0, 17)}...`, tooltipColuna: el.nome } : el.nome
        arr.push(verificoNomeAplicacaoPrecisaTooltip)
        arr.push(el.token)
        arr.push(el.dataGeracao)
        arr.push(el.dataExpiracao)

        let a = '<div v-if="hoverIndex !== index" class="primary2 circle-status"/>'
        let b = '<div v-else-if="hoverIndex !== index" class="error circle-status"/>'
        let s = el.status ? a : b
        let temp = document.createElement('div')
        temp = s

        this.htmlArr.push(temp)
        this.rowsData.push(arr)
        arr = []
      })
    })
  },
  TabelaMunicipioIBGE() {
    this.rowsData = []

    this.$nextTick(() => {
      let arr = []

      this.rows.forEach((el) => {
        arr.push(el.id)
        arr.push(el.nome)
        arr.push(el.regiao.nome)
        arr.push(el.regiao.estado.sigla)

        this.rowsData.push(arr)

        arr = []
      })
    })
  },
  tabelaTags() {
    this.rowsData = []

    this.$nextTick(() => {
      let arr = []

      this.rows.forEach((el) => {
        arr.push(el.tag)

        this.rowsData.push(arr)
        this.htmlArr.push('<div/>')

        arr = []
      })
    })
  },
  hierarquiaAdministracao() {
    this.rowsData = []
    this.htmlArr = []

    this.$nextTick(() => {
      let arr = []

      const tooltipoSub = (element) => {
        return element.length >= 25 ? { nome: `${element.substring(0, 25)}...`, tooltipColuna: element } : element
      }

      this.rows.forEach((el) => {
        arr.push(el.unimed ? tooltipoSub(el.unimed.textoExibicao) : ' - ')
        arr.push(el.hierarquia1 ? tooltipoSub(el.hierarquia1.textoExibicao) : ' - ')
        arr.push(el.hierarquia2 ? tooltipoSub(el.hierarquia2.textoExibicao) : ' - ')
        arr.push(el.hierarquia3 ? tooltipoSub(el.hierarquia3.textoExibicao) : ' - ')
        arr.push(el.segundaFiliacao ? tooltipoSub(el.segundaFiliacao.textoExibicao) : ' - ')

        let s = `
          <div> ${el.dataUltimaAtualizacao || ' - '} </div>
        `
        let temp = document.createElement('div')
        temp = s

        this.rowsData.push(arr)
        this.htmlArr.push(temp)
        arr = []
      })
    })
  },
  mCPF(cpf) {
    cpf = cpf.replace(/\D/g, '')
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    return cpf
  },
  dirigentes() {
    this.rowsData = []
    this.htmlArr = []

    this.$nextTick(() => {
      let arr = []
      const mostrarCpf = this.rows.length === 0 || Object.prototype.hasOwnProperty.call(this.rows[0], 'cpf')

      this.rows.forEach((el) => {
        arr.push(el.tratamento, el.nome)
        if (mostrarCpf) arr.push(el.cpf ? this.mCPF(el.cpf) : '')
        arr.push(el.crm)

        let s = `
          <div> ${el.estadoCrm ? el.estadoCrm.sigla : ''} </div>
        `
        let temp = document.createElement('div')
        temp = s

        this.rowsData.push(arr)
        this.htmlArr.push(temp)

        arr = []
      })
    })
  },
  dirigentesCargos() {
    this.rowsData = []
    this.htmlArr = []

    this.$nextTick(() => {
      let arr = []

      this.rows.forEach((el) => {
        const codigo = el.unimed.codigo || ''
        const nomeFantasia = el.unimed.nomeFantasia || ''
        const nomeMandato = el.dirigenteCargo.cargo.nome || ''
        const dataInicio = el.mandato.dataInicioVigencia || ''
        const dataFim = el.mandato.dataFimVigencia || ''

        arr.push(codigo, nomeFantasia, nomeMandato, dataInicio, dataFim)

        let a = '<div class="primary2 circle-status"/>'
        let b = '<div class="error circle-status"/>'
        let s = el.mandato.vigente ? a : b

        let temp = document.createElement('div')
        temp = s

        this.rowsData.push(arr)
        this.htmlArr.push(temp)

        arr = []
      })
    })
  }
}
